export default "__VITE_ASSET__2216259a__"